import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getLastFinishedJob, verifyOtp, sendOtp, cancelJob, getBids, acceptBid, getWinningBid, addRating, parseJobThankyou, getTypeTextGlobal } from '../../redux/Actions';
import { Redirect } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import ReactStars from 'react-stars';

import './Thankyou.css';

class Thankyou extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_className: ['apps-gotlocked-order'],
            phonenumber: "",
            cancel_reason: "",
            token: null,
            job: null,
            improve_text: "",
            overal_rating: 0,
            tech_rating: 0,

            loader: true,
            redirect: false,
        }
    }

    componentDidMount() {
        //document.body.classNameList.add(...this.state.body_className);
        setTimeout(function () {
            this.props.getLastFinishedJob();
            setTimeout(function () {
                if (this.props.finished_job) {
                    this.props.getWinningBid(this.props.finished_job.id);
                } else {
                    this.setState({
                        redirect: true
                    });
                }
            }.bind(this), 1000);
            this.setState({
                loader: false
            });
        }.bind(this), 3000);
    }

    componentDidUpdate(prevProps) {
        if (this.state.token === null && this.state.token !== this.props.token) {
            this.setState({
                token: this.props.token
            });
        }
        if (this.state.job === null && this.props.finished_job != undefined && this.state.job !== this.props.finished_job) {
            this.setState({
                job: parseJobThankyou(this.props.finished_job)
            });
        }
    }

    getTypeText() {
        let text = 'House Lockout';
        if (this.state.job !== null) {
            text = getTypeTextGlobal(this.state.job.job_type);
        }
        return text;
    }

    sendRating() {
        let rating_data = {
            jobid: this.props.finished_job.id,
            overal_rating: this.state.overal_rating,
            tech_rating: this.state.tech_rating,
            note: this.state.improve_text
        }
        this.props.addRating(rating_data);
        this.setState({
            redirect: true
        });
    }

    getPaymentText() {
        let payment_text = ""
        switch(this.state.job.payment_method) {
            case 'credit_card':
                payment_text = "Credit Card";
                break;
            case 'cash':
                payment_text = "Cash";
                break;
        }
        return payment_text;
    }

    render() {
        if (this.state.redirect) {
            return (<Redirect push to='/order' />);
        }
        let order_information = this.state.job ? <div>
            <p><strong>Service total:</strong> {this.props.winning_bid.bid_price}$ <strong>with ETA:</strong> {this.props.winning_bid.eta}</p>
            <p><strong>Service type:</strong> {this.getTypeText()}, <strong>Payment type:</strong> {this.getPaymentText()}</p>
            <p><strong>Provided by:</strong> {this.props.winning_bid.tech_name}</p>
        </div> : null;

        return (
            <div>
                <Loader
                    type="Watch"
                    color="#fcae4b"
                    height={100}
                    width={100}
                    visible={this.state.loader}
                    className="loader"
                />
                <div className="apps-gotlocked-video-bg-section"></div>
                <section className="apps-gotlocked-order-section" id="apps-gotlocked-order">
                    <div className="apps-gotlocked-order-container">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 payment_page_form">
                                    <div className="apps-gotlocked-thankyou">
                                        <div className="row">
                                            <div className="col">
                                                <div className="jumbotron">
                                                    <h1 className="display-3 apps-gotlocked-order-tbl-c text-center">Thank You</h1>
                                                    {/* <p className="lead"><strong>THANK YOU</strong> for your order.</p> */}
                                                    <div className="text-center">
                                                        {order_information}
                                                    </div>
                                                    <hr />
                                                    <Form className="rateForm">
                                                        <Form.Group controlId="exampleForm.ControlTextarea1">
                                                            <Form.Label>How would you rate your overall experience?</Form.Label>
                                                            <ReactStars count={5} className="tech-stars" size={48} color2={'#ffd700'} edit={true} value={this.state.overal_rating} onChange={(rating) => { this.setState({ overal_rating: rating }); }} />
                                                        </Form.Group>
                                                        <Form.Group controlId="exampleForm.ControlInput1">
                                                            <Form.Label>How would you rate the service provider?</Form.Label>
                                                            <ReactStars count={5} className="tech-stars" size={48} color2={'#ffd700'} edit={true} value={this.state.tech_rating} onChange={(rating) => { this.setState({ tech_rating: rating }); }} />
                                                        </Form.Group>
                                                        <Form.Group controlId="exampleForm.ControlTextarea1">
                                                            <Form.Label>Tell us what we need to improve</Form.Label>
                                                            <Form.Control as="textarea" rows="3" onChange={(event) => { this.setState({ improve_text: event.target.value }); }}/>
                                                        </Form.Group>
                                                        <Button variant="primary" type="submit" onClick={() => this.sendRating()}>
                                                            Submit
                                                        </Button>
                                                    </Form>
                                                    <hr />
                                                    <div className="text-center">
                                                        <p>Having trouble? <a href="/contact">Contact us</a></p>
                                                        <p className="lead">
                                                            <a className="btn btn-warning" href="/" role="button">continue to homepage</a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { finished_job, token, bids, winning_bid } = state;
    return { finished_job, token, bids, winning_bid };
};

export default connect(mapStateToProps, { getLastFinishedJob, verifyOtp, sendOtp, cancelJob, getBids, acceptBid, getWinningBid, addRating })(Thankyou);